/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'

/**
 * Import
 * - Actions
 */
import { getPolicySingle, fetchTradeFairsLocations } from '../../../../../actions'

/**
 * Import
 * - Page component
 */
import CoverOptions from '../components/CoverOptions'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
        tradeFairsLocations: state.step00.tradeFairsLocations,
    }
}

export default connect(
    mapStateToProps,
    {
        getPolicySingle: getPolicySingle,
        fetchTradeFairsLocations,
    }
)(CoverOptions)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/containers/CoverOptions.tsx